import { render, staticRenderFns } from "./agGrid.vue?vue&type=template&id=46559912&"
import script from "./agGrid.vue?vue&type=script&lang=js&"
export * from "./agGrid.vue?vue&type=script&lang=js&"
import style0 from "./agGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
